import React from "react";
import { Link } from "react-router-dom";
import { Button } from "./ui/button";
import { ArrowRight, ShieldCheck, Award, Flame, CheckCircle2 } from "lucide-react";
import { products } from "../mock";

export default function StaticHero() {
  const featured = products[0];
  return (
    <section className="relative w-full overflow-hidden bg-cream bg-dotted">
      {/* Decorative accents */}
      <div className="absolute -top-32 -right-32 w-[420px] h-[420px] rounded-full bg-orange-500/10 blur-3xl pointer-events-none" />
      <div className="absolute -bottom-40 -left-20 w-[360px] h-[360px] rounded-full bg-orange-500/10 blur-3xl pointer-events-none" />
      <div className="absolute top-1/4 right-10 w-2 h-24 bg-orange-500 rotate-12 opacity-70 pointer-events-none hidden lg:block" />
      <div className="absolute top-1/3 right-24 w-2 h-16 bg-orange-500 rotate-12 opacity-50 pointer-events-none hidden lg:block" />

      <div className="relative max-w-7xl mx-auto px-6 py-16 md:py-24 grid lg:grid-cols-2 gap-10 items-center">
        <div className="fade-up">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-orange-100 text-orange-600 text-[11px] font-bold tracking-widest uppercase">
            <Flame size={12} /> Engineered Heat. Endless Possibilities.
          </span>
          <h1 className="font-display text-4xl md:text-6xl font-bold mt-5 leading-tight uppercase text-neutral-900">
            Industrial Infrared Heating, <span className="text-orange-500">Reimagined</span>
          </h1>
          <span className="block w-24 h-[3px] bg-orange-500 mt-6" />
          <p className="mt-5 text-base md:text-lg text-neutral-600 max-w-xl">
            Built for performance. Designed for endurance. Tailored for your industry.
          </p>

          <div className="mt-8 flex flex-wrap gap-4">
            <Link to="/products">
              <Button className="bg-orange-500 hover:bg-orange-600 text-white rounded-full px-7 py-6 font-semibold tracking-wider uppercase">
                Explore Products <ArrowRight size={16} className="ml-2" />
              </Button>
            </Link>
            <Link to="/contact">
              <Button
                variant="outline"
                className="bg-transparent border-neutral-900 text-neutral-900 hover:bg-neutral-900 hover:text-white rounded-full px-7 py-6 font-semibold tracking-wider uppercase"
              >
                Get a Quote
              </Button>
            </Link>
          </div>

          <div className="mt-10 flex flex-wrap items-center gap-x-7 gap-y-3 text-sm text-neutral-700">
            <span className="flex items-center gap-2">
              <ShieldCheck size={18} className="text-orange-500" />
              ISO 9001:2015 Certified
            </span>
            <span className="hidden md:inline-block w-1 h-1 rounded-full bg-orange-500" />
            <span className="flex items-center gap-2">
              <Award size={18} className="text-orange-500" />
              25+ Years of Excellence
            </span>
            <span className="hidden md:inline-block w-1 h-1 rounded-full bg-orange-500" />
            <span className="flex items-center gap-2">
              <CheckCircle2 size={18} className="text-orange-500" />
              Trusted by 1000+ Clients
            </span>
          </div>
        </div>

        {/* Right side - product showcase card */}
        <div className="relative hidden lg:block">
          <div className="relative bg-white rounded-3xl shadow-2xl ring-1 ring-orange-100 p-8 lift-on-hover">
            <span className="absolute top-5 left-5 inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-orange-500 text-white text-[10px] font-bold tracking-widest uppercase">
              <Flame size={12} /> Featured
            </span>
            <span className="absolute top-5 right-5 inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-neutral-900 text-white text-[10px] font-bold tracking-widest uppercase">
              <ShieldCheck size={12} /> ISO 9001
            </span>
            <img src={featured.image} alt={featured.name} className="w-full h-[340px] object-contain mt-6" />
            <div className="mt-6 text-center border-t border-neutral-100 pt-5">
              <h3 className="font-display text-xl uppercase">{featured.name}</h3>
              <span className="block w-12 h-[3px] bg-orange-500 mx-auto mt-3" />
              <p className="mt-3 text-sm text-neutral-600 max-w-md mx-auto">{featured.short}</p>
            </div>
          </div>

          {/* Floating stat card */}
          <div className="absolute -bottom-5 -left-4 bg-neutral-900 text-white px-5 py-4 rounded-xl shadow-xl">
            <p className="font-display text-2xl font-bold leading-none text-orange-500">25+</p>
            <p className="text-[10px] uppercase tracking-widest mt-1">Years Excellence</p>
          </div>
          <div className="absolute -top-5 -right-2 bg-orange-500 text-white px-5 py-4 rounded-xl shadow-xl">
            <p className="font-display text-2xl font-bold leading-none">1000+</p>
            <p className="text-[10px] uppercase tracking-widest mt-1">Happy Clients</p>
          </div>
        </div>
      </div>
    </section>
  );
}
